export class EvalResponse {
  public evaluatedResponseObject: any;
  public evalSuccess: boolean = false;
}
